import React from "react";
import { IoCloseOutline } from "react-icons/io5";

const CampaignsListWrapper = ({ children, onClose, isOpen }) => {
  // Desktop version
  const DesktopSidebar = () => (
    <div className="hidden md:block h-auto w-1/4 bg-white/50 overflow-y-auto border border-gray-300 rounded-lg p-3 scrollbar-thin">
      {children}
    </div>
  );
  const MobileModal = () => (
    <div
      className={`h-60 md:h-auto md:w-1/4 bg-white/50 overflow-y-auto border border-gray-300 rounded-lg p-3 scrollbar-thin
     ${isOpen ? "block" : "hidden"}
    `}>
      {/* Overlay */}
      <div
        className="z-10 fixed inset-0 backdrop-blur-sm bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      {/* Modal Content */}
      <div className="z-20 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 pt-0 rounded-lg w-11/12 max-h-[80vh] overflow-y-auto scrollbar-thin">
        {/* Header */}
        <div className="sticky pt-2 top-0 bg-white mb-5 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">
            Campaings List
          </h3>
          <button
            onClick={onClose}
            className="rounded-full p-1 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100">
            <IoCloseOutline size={24} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
  return (
    <>
      <DesktopSidebar />
      <MobileModal />
    </>
  );
};

export default CampaignsListWrapper;
